import { render, staticRenderFns } from "./swiper-button-tertiary.vue?vue&type=template&id=c8b20798&scoped=true&"
import script from "./swiper-button-tertiary.vue?vue&type=script&lang=js&"
export * from "./swiper-button-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b20798",
  null
  
)

export default component.exports